import { Link } from 'react-router-dom';

export default function ProductsHero() {
  return (
    <section className="relative bg-[#0B2C26] pt-28 pb-20 overflow-hidden">
      <div className="absolute inset-0 opacity-20">
        <img
          src="https://public.readdy.ai/ai/img_res/73ca89798f792038fefc80a205b0a908.jpg"
          alt="Product range"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="relative z-10 max-w-7xl mx-auto px-6 text-center">
        <div className="inline-flex items-center gap-2 bg-[#FF6B35]/20 border border-[#FF6B35]/40 rounded-full px-4 py-1.5 mb-5 backdrop-blur-sm">
          <i className="ri-sun-fill text-[#FF6B35] text-sm" />
          <span className="text-[#FF6B35] text-xs font-bold uppercase tracking-widest">Sun-Powered Repair Range</span>
        </div>
        <h1 className="text-4xl md:text-6xl font-black text-white mb-5">
          Find Your Perfect<br />
          <span className="text-[#FF6B35]">Repair Kit</span>
        </h1>
        <p className="text-stone-400 text-lg max-w-xl mx-auto mb-8">
          Professional-grade sun-powered repair kits for every board type. Cures in minutes. Works anywhere with sunlight.
        </p>
        <div className="flex flex-wrap gap-3 justify-center mb-10">
          {['Epoxy Boards', 'Polyester Boards', 'Soft-tops', 'Travel Kits', 'Bio-Resin'].map((tag) => (
            <span key={tag} className="bg-white/10 border border-white/20 text-white/80 text-xs font-semibold px-3 py-1.5 rounded-full">
              {tag}
            </span>
          ))}
        </div>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a href="#product-grid" className="whitespace-nowrap bg-[#FF6B35] text-white font-bold px-8 py-4 rounded-full hover:bg-[#e55a25] transition-colors cursor-pointer">
            Browse All Kits
          </a>
          <Link to="/where-to-buy" className="whitespace-nowrap border-2 border-white/30 text-white font-bold px-8 py-4 rounded-full hover:bg-white/10 transition-colors cursor-pointer">
            Find a Store Near You
          </Link>
        </div>
      </div>
    </section>
  );
}
